import type { RentalTemplateContextConfig } from "#lib/web-ui/rental/index.js";
import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

export const elevationSiteConfig: RentalTemplateContextConfig = {
	name: "Elevation on Airline",
	tagline: "LIVE ELEVATED",
	logo: cloudinaryUrl("brand/elevation-on-airline/elevation-on-airline-long-dark", {
		width: 300
	}),
	address: {
		street: "903 Linwood Dr",
		city: "Victoria",
		state: "TX",
		zip: "77901"
	},
	geo: {
		latitude: "28.8244281",
		longitude: "-96.970389"
	},
	amenities: ["Swimming Pool", "Laundry Facilities", "Covered Parking", "Pet Friendly"],
	priceRange: "$$",
	metaDescription:
		"Discover Elevation on Airline apartments in Victoria, TX - your serene oasis featuring spacious 1-2 bedroom apartments with updated countertops, oversized closets, and modern finishes. Enjoy our swimming pool, on-site management, and prime location near Texas A&M University-Victoria and Victoria College.",
	metaKeywords:
		"Elevation on Airline, apartments Victoria TX, Victoria TX apartments, apartments for rent Victoria TX, 1 bedroom apartments Victoria TX, 2 bedroom apartments Victoria TX, 3 bedroom apartments Victoria TX, apartments 77901, Linwood Dr apartments, apartments near Texas A&M University-Victoria, apartments near University of Houston Victoria, apartments near Victoria College, pet-friendly apartments Victoria TX, apartments with pool Victoria TX, apartments with private patios Victoria TX, apartments with balconies Victoria TX, apartments with on-site laundry Victoria TX, apartments with covered parking Victoria TX, apartments with assigned parking, spacious apartments Victoria TX, quiet apartments Victoria TX, modern finish apartments Victoria TX, Victoria Texas rentals, Elevation on Airline rentals, apartments near downtown Victoria TX, apartments near Victoria Mall, apartments near Riverside Park",
	buildiumPropertyIds: [],
	tenantPortal: "https://fergmar.managebuilding.com/Resident/portal/",
	contact: {
		phone: "(361) 326-3734",
		email: "leasing@elevationonairline.com"
	},
	events: [],
	eventImage: cloudinaryUrl("www/elevationonairline-com/pool", { width: 800 }),
	websiteUrl: "elevationonairline.com",
	socialMedia: {
		facebook: "https://facebook.com/elevationonairline",
		instagram: "https://instagram.com/elevationonairline"
	},
	heroImage: cloudinaryUrl("www/elevationonairline-com/pool", { width: 1920 }),
	heroVideoPublicId: "www/elevationonairline-com/background-video",
	apartmentFeatures: [
		"Private Patios or Balconies",
		"On-site Laundry Facility",
		"Cable Ready",
		"Spacious 1 and 2 Bedroom Floor Plans",
		"Ceiling Fans in Bedrooms"
	],
	communityFeatures: [
		"Spacious Grounds",
		"Quiet Setting",
		"Community Pool",
		"Convenient Access to Schools and Shopping",
		"24 Hour Emergency Maintenance",
		"Covered & Assigned Parking"
	],
	detailsImage: cloudinaryUrl("www/elevationonairline-com/pool", { width: 800 }),
	neighborhood: [
		"Minutes from downtown",
		"Riverside Park",
		"The Texas Zoo",
		"Riverside Golf Course",
		"Rose Garden",
		"Theatre Victoria",
		"Victoria Mall",
		"Close to businesses and restaurants",
		"By Victoria College and University of Houston",
		"Home to the Victoria Independent School District"
	],
	floorPlans: [
		{
			key: "a1",
			name: "A1",
			beds: 1,
			baths: 1,
			sqFt: { min: 700, max: 700 },
			image: cloudinaryUrl("www/elevationonairline-com/1bed-1bath", { width: 600 }),
			deposit: null
		},
		{
			key: "b1",
			name: "B1",
			beds: 2,
			baths: 1,
			sqFt: { min: 866, max: 866 },
			image: cloudinaryUrl("www/elevationonairline-com/2bed-1bath", { width: 600 }),
			deposit: null
		},
		{
			key: "c1",
			name: "C1",
			beds: 2,
			baths: 2,
			sqFt: { min: 950, max: 950 },
			image: cloudinaryUrl("www/elevationonairline-com/2bed-2bath", { width: 600 }),
			deposit: null
		},
		{
			key: "d1",
			name: "D1",
			beds: 3,
			baths: 2,
			sqFt: { min: 1026, max: 1026 },
			image: cloudinaryUrl("www/elevationonairline-com/3bed-2bath", { width: 600 }),
			deposit: null
		}
	],
	propertyImages: [
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (1)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (2)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (3)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (4)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (5)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (6)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (7)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/elevation-on-airline-apartments (8)", {
				width: 1200
			}),
			alt: "Elevation on Airline Apartments"
		},
		{
			url: cloudinaryUrl("www/elevationonairline-com/pool", { width: 1200 }),
			alt: "Elevation on Airline Apartments"
		}
	],
	integrations: {
		knock: {
			propertyId: "71f10e8e382911e8b41b0ee4545fea9e",
			communityId: "4a498a23411f1450"
		}
	},
	welcomeTagline: "LIVE LIFE ELEVATED",
	welcomeDescription:
		"Elevation on Airline Apartments is more than just a place to live! The perfect blend of convenience, spaciousness, and variety makes our community the sensible choice for those seeking the perfect place to call home. Elevation on Airline Apartments are conveniently located off North Navarro, beyond Loop 463 and right on East Larkspur. Our quiet location provides easy access to your favorite restaurants, shopping, and entertainment venues, including the Victoria Mall, Wal-Mart, and Cinemark Theatres."
} as const;
